'use strict';

exports.__esModule = true;
exports.types = exports.errors = exports.parseMediaItemUri = exports.createMediaItemUri = exports.isValidMediaItemUri = undefined;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var templates = {
  vector: function vector(svgId, filename) {
    return 'wix:vector://v1/' + svgId + '/' + filename;
  },
  image: function image(uri, filename, width, height, watermark) {
    return 'wix:image://v1/' + uri + '/' + filename + '#originWidth=' + width + '&originHeight=' + height + (watermark ? '&watermark=' + watermark : '');
  },
  document: function document(uri, filename) {
    return 'wix:document://v1/' + uri + '/' + filename;
  },
  video: function video(videoId, posterId, filename, width, height) {
    return 'wix:video://v1/' + videoId + '/' + filename + '#posterUri=' + posterId + '&posterWidth=' + width + '&posterHeight=' + height;
  },
  audio: function audio(uri, filename, duration) {
    return 'wix:audio://v1/' + uri + '/' + filename + '#duration=' + duration;
  }
}; /*
    * Media Item Utils
    * April 2018
    * tombigel@wix.com
    */

var matchers = {
  vector: /^wix:vector:\/\/v1\/([^\/]+)\/([^\/]*)$/,
  image: /^wix:image:\/\/v1\/([^\/]+)\/([^\/]+)#originWidth=([0-9]+)&originHeight=([0-9]+)(?:&watermark=([^\/]+))?$/,
  document: /^wix:document:\/\/v1\/([^\/]+)\/([^\/]+)$/,
  video: /^wix:video:\/\/v1\/([^\/]+)\/([^\/]+)#posterUri=([^\/]+)&posterWidth=([0-9]+)&posterHeight=([0-9]+)$/,
  audio: /^wix:audio:\/\/v1\/([^\/]+)\/([^\/]+)#duration=([0-9]+)$/,
  deprecated_video: /^wix:video:\/\/v1\/([^\/]+)\/([^\/]+)\/#posterUri=([^\/]+)&posterWidth=([0-9]+)&posterHeight=([0-9]+)$/,
  deprecated_image: /^image:\/\/v1\/([^\/]+)\/([0-9]+)_([0-9]+)\/([^\/]*)$/,
  deprecated_type: /^(image):/,
  type: /^wix:(\w+):/,
  splitExtension: /\.(?=[^.]+$)/,
  emptyTitle: /^_\./
};

var matchersByType = {
  vector: [matchers.vector],
  image: [matchers.image, matchers.deprecated_image],
  document: [matchers.document],
  video: [matchers.video, matchers.deprecated_video],
  audio: [matchers.audio]

  /**
   * @typedef {string} MediaType
   */
  /**
   * @public
   * @type {{IMAGE: MediaType, DOCUMENT: MediaType, VIDEO: MediaType, AUDIO: MediaType, VECTOR: MediaType}}
   */
};var types = {
  IMAGE: 'image',
  DOCUMENT: 'document',
  VIDEO: 'video',
  AUDIO: 'audio',
  VECTOR: 'vector'

  /**
   * @public
   * @type {{empty_media_id: string, empty_poster_id: string, bad_media_id: string, unknown_media_type: string, missing_width_height: string}}
   */
};var errors = {
  empty_media_id: 'empty_media_id',
  empty_poster_id: 'empty_poster_id',
  bad_media_id: 'bad_media_id',
  unknown_media_type: 'unknown_media_type',
  missing_width_height: 'missing_width_height',
  non_string_media_id: 'non_string_media_id'

  /**
   * Return a file name, use the extension from uri if the title has none
   * @param {string} type
   * @param {string} [title]
   * @param {string} uri
   * @returns {string}
   */
};function convertTitleToFilename(type) {
  var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var uri = arguments[2];

  var _uri$split = uri.split(matchers.splitExtension),
      uriName = _uri$split[0],
      uriExtension = _uri$split[1];

  var _title$split = title.split(matchers.splitExtension),
      titleName = _title$split[0],
      titleExtension = _title$split[1];

  var filename = '';

  switch (type) {
    case types.IMAGE:
      filename = (titleName || '_') + '.' + (titleExtension || uriExtension);
      break;
    case types.DOCUMENT:
      filename = (titleName || uriName) + '.' + (titleExtension || uriExtension);
      break;
    case types.VIDEO:
      filename = '' + (titleName || '_') + (titleExtension ? '.' + titleExtension : '');
      break;
    case types.AUDIO:
      filename = (titleName || uriName) + '.' + (titleExtension || uriExtension);
      break;
    case types.VECTOR:
      filename = (titleName || uriName) + '.' + (titleExtension || uriExtension);
      break;
  }
  return encodeURI(filename);
}

/**
 * return filename or an empty string
 * @param {string} filename
 * @returns {string}
 */
function convertFilenameToTitle(filename) {
  return matchers.emptyTitle.test(filename) ? '' : decodeURI(filename);
}

/**
 * Create a MediaItem for an image, width and height are mandatory numbers
 * @param {string} uri
 * @param {string} [title]
 * @param {number} width
 * @param {number} height
 * @param {string} [watermark]
 * @returns {{item: string}|{error: string}}
 */
function createImageItem(uri, title, width, height, watermark) {
  if (!uri) {
    return { error: errors.empty_media_id };
  }

  if (isNaN(height) || isNaN(width)) {
    return { error: errors.missing_width_height };
  }

  var filename = convertTitleToFilename(types.IMAGE, title, uri);
  return { item: templates.image(uri, filename, width, height, watermark) };
}

/**
 * Create a MediaItem for a document
 * @param {string} uri
 * @param {string} [title]
 * @returns {{item: string}|{error: string}}
 */
function createDocumentItem(uri, title) {
  if (!uri) {
    return { error: errors.empty_media_id };
  }
  var filename = convertTitleToFilename(types.DOCUMENT, title, uri);
  return { item: templates.document(uri, filename) };
}

/**
 * Create a MediaItem for a vector image
 * @param {string} svgId
 * @param {string} [title]
 * @returns {{item: string}|{error: string}}
 */
function createVectorItem(svgId, title) {
  if (!svgId) {
    return { error: errors.empty_media_id };
  }
  var filename = convertTitleToFilename(types.VECTOR, title, svgId);
  return { item: templates.vector(svgId, filename) };
}

/**
 * Create a MediaItem for a video, posterId is a mandatory image uri, width and height are mandatory numbers
 * @param {string} videoId
 * @param {string} [title]
 * @param {number} width
 * @param {number} height
 * @param {string} posterId
 * @returns {{item: string}|{error: string}}
 */
function createVideoItem(videoId, title, width, height, posterId) {
  if (!videoId) {
    return { error: errors.empty_media_id };
  }
  if (!posterId) {
    return { error: errors.empty_poster_id };
  }
  if (isNaN(height) || isNaN(width)) {
    return { error: errors.missing_width_height };
  }
  videoId = videoId.replace('video/', '');

  var filename = convertTitleToFilename(types.VIDEO, title, videoId);
  return { item: templates.video(videoId, posterId, filename, width, height) };
}

/**
 * Create a MediaItem for a audio
 * @param {string} uri
 * @param {string} [title]
 * @param {number} [duration]
 * @returns {{item: string}|{error: string}}
 */
function createAudioItem(uri, title, duration) {
  if (!uri) {
    return { error: errors.empty_media_id };
  }
  var filename = convertTitleToFilename(types.AUDIO, title, uri);
  return { item: templates.audio(uri, filename, duration) };
}

/**
 * Parse an image MediaItem
 * @param {string} item
 * @returns {{type: MediaType, mediaId: string, title: string, width: number, height: number, watermark?: string}|{error: string}}
 */
function parseImageItem(item) {
  var _ref = item.match(matchers.image) || [],
      mediaId = _ref[1],
      filename = _ref[2],
      width = _ref[3],
      height = _ref[4],
      watermark = _ref[5];

  var title = convertFilenameToTitle(filename);

  if (mediaId) {
    var parsed = {
      type: types.IMAGE,
      mediaId: mediaId,
      title: title,
      width: parseInt(width, 10),
      height: parseInt(height, 10)
    };
    if (watermark) {
      parsed.watermark = watermark;
    }
    return parsed;
  }
  return { error: errors.bad_media_id };
}

function parseDeprecatedImageItem(item) {
  var _ref2 = item.match(matchers.deprecated_image) || [],
      mediaId = _ref2[1],
      width = _ref2[2],
      height = _ref2[3],
      filename = _ref2[4];

  var title = convertFilenameToTitle(filename);

  if (mediaId) {
    return {
      type: types.IMAGE,
      mediaId: mediaId,
      title: title,
      width: parseInt(width, 10),
      height: parseInt(height, 10)
    };
  }
  return { error: errors.bad_media_id };
}

/**
 * Parse a document MediaItem
 * @param {string} item
 * @returns {{type: MediaType, mediaId: string, title: string}|{error: string}}
 */
function parseDocumentItem(item) {
  var _ref3 = item.match(matchers.document) || [],
      mediaId = _ref3[1],
      filename = _ref3[2];

  var title = convertFilenameToTitle(filename);

  if (mediaId) {
    return {
      type: types.DOCUMENT,
      mediaId: mediaId,
      title: title
    };
  }
  return { error: errors.bad_media_id };
}

/**
 * Parse a vector MediaItem
 * @param {string} item
 * @returns {{type: MediaType, mediaId: string, title: string}|{error: string}}
 */
function parseVectorItem(item) {
  var _ref4 = item.match(matchers.vector) || [],
      mediaId = _ref4[1],
      filename = _ref4[2];

  var title = convertFilenameToTitle(filename);

  if (mediaId) {
    return {
      type: types.VECTOR,
      mediaId: mediaId,
      title: title
    };
  }
  return { error: errors.bad_media_id };
}

/**
 * Parse a video MediaItem
 * @param {string} item
 * @returns {{type: MediaType, mediaId: string, posterId: string, width: number, height: number, title: string}|{error: string}}
 */
function parseVideoItem(item) {
  var videoMatcher = matchers.deprecated_video.test(item) ? matchers.deprecated_video : matchers.video;

  var _ref5 = item.match(videoMatcher) || [],
      mediaId = _ref5[1],
      filename = _ref5[2],
      posterId = _ref5[3],
      width = _ref5[4],
      height = _ref5[5];

  var title = convertFilenameToTitle(filename);

  if (mediaId && posterId) {
    return {
      type: types.VIDEO,
      mediaId: mediaId,
      posterId: posterId,
      width: parseInt(width, 10),
      height: parseInt(height, 10),
      title: title
    };
  }
  return { error: errors.bad_media_id };
}

/**
 * Parse a audio MediaItem
 * @param {string} item
 * @returns {{type: MediaType, mediaId: string, title: string, duration: number}|{error: string}}
 */
function parseAudioItem(item) {
  var _ref6 = item.match(matchers.audio) || [],
      mediaId = _ref6[1],
      filename = _ref6[2],
      duration = _ref6[3];

  var title = convertFilenameToTitle(filename);

  if (mediaId) {
    return {
      type: types.AUDIO,
      mediaId: mediaId,
      title: title,
      duration: parseInt(duration, 10)
    };
  }
  return { error: errors.bad_media_id };
}

/**
 * @public
 * Create a MediaItem in the form of 'wix:<media_type>:<uri>/...' of one of the supported type
 * @param {string} mediaId required for all types
 * @param {MediaType} type required, one of the supported types
 * @param {string} [title] optional for all types
 * @param {number} [width] required for video and image
 * @param {number} [height] required for video and image
 * @param {string} [posterId] required for video
 * @param {string} [watermark] optional for image
 * @param {number} [duration] optional for audio
 * @returns {{item: string}|{error: string}}
 */
function createMediaItemUri(_ref7) {
  var mediaId = _ref7.mediaId,
      type = _ref7.type,
      title = _ref7.title,
      width = _ref7.width,
      height = _ref7.height,
      posterId = _ref7.posterId,
      watermark = _ref7.watermark,
      duration = _ref7.duration;

  switch (type) {
    case types.IMAGE:
      return createImageItem(mediaId, title, width, height, watermark);
    case types.DOCUMENT:
      return createDocumentItem(mediaId, title);
    case types.VECTOR:
      return createVectorItem(mediaId, title);
    case types.VIDEO:
      return createVideoItem(mediaId, title, width, height, posterId);
    case types.AUDIO:
      return createAudioItem(mediaId, title, duration);
    default:
      return { error: errors.unknown_media_type };
  }
}

/**
 * @public
 * Parse a media item url of one of the supported types
 * @param {string} mediaItemUri
 * @returns {{}|{error: string}}
 */
function parseMediaItemUri() {
  var mediaItemUri = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (!_lodash2.default.isString(mediaItemUri)) {
    return { error: errors.non_string_media_id };
  }

  var _ref8 = mediaItemUri.match(matchers.type) || [],
      type = _ref8[1];

  switch (type) {
    case types.IMAGE:
      return parseImageItem(mediaItemUri);
    case types.DOCUMENT:
      return parseDocumentItem(mediaItemUri);
    case types.VECTOR:
      return parseVectorItem(mediaItemUri);
    case types.VIDEO:
      return parseVideoItem(mediaItemUri);
    case types.AUDIO:
      return parseAudioItem(mediaItemUri);
    default:
      var _ref9 = mediaItemUri.match(matchers.deprecated_type) || [],
          deprecatedType = _ref9[1];

      if (deprecatedType) {
        return parseDeprecatedImageItem(mediaItemUri);
      }
      return { error: errors.unknown_media_type };
  }
}

/**
 * @public
 * Checks if a given url is a valid media item url
 * @param {string} mediaItemUri
 * @param {string} type
 * @returns {boolean}
 */
function isValidMediaItemUri() {
  var mediaItemUri = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var type = arguments[1];

  var matchers = matchersByType[type];
  return _lodash2.default.some(matchers, function (matcher) {
    return matcher.test(mediaItemUri);
  });
}

exports.isValidMediaItemUri = isValidMediaItemUri;
exports.createMediaItemUri = createMediaItemUri;
exports.parseMediaItemUri = parseMediaItemUri;
exports.errors = errors;
exports.types = types;
//# sourceMappingURL=mediaItemUtils.js.map